import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-alunos',
  templateUrl: 'alunos.html',
})
export class AlunosPage {

  formModal: any = {
    id: null,
    nome: "",
    email: "",
    cpf: "",
    telefone: "",
    cep: "",
    logradouro: "",
    bairro: "",
    cidade: "",
    estado: "",
    numero: "",
    eh_maior: 0,
    nome_responsavel: "",
    cpf_responsavel: "",
    telefone_responsavel: ""
  }

  form: any = {
    status: "",
    search_responsavel: "",
    eh_maior: "",
    search: "",
    page: 1,
    date_start: "",
    date_end: "",
    forpage: 10
  }

  resultData: any = null;
  urlSearch = "/alunos";

  public targetModal: string = "modal-new-aluno";

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private msgHelper: MessageHelper, private service: ServiceProvider,
    private alertCtrl: AlertController) {
  }

  ionViewWillEnter() {
    this.search();
  }

  /**
   * Abre o modal
   */
  public new() {
    this.formModal = {
      id: null,
      nome: "",
      email: "",
      telefone: "",
      cpf: "",
      cep: "",
      logradouro: "",
      bairro: "",
      cidade: "",
      estado: "",
      numero: "",
      eh_maior: 0,
      nome_responsavel: "",
      cpf_responsavel: "",
      telefone_responsavel: ""
    };
    document.getElementById(this.targetModal).classList.add("show");
  }

  /**
   * Salva no banco
   */
  public save() {
    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formModal, this.urlSearch + "/save", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById(this.targetModal).classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  public update(obj: any) {
    this.formModal.id = obj.id;
    this.formModal.eh_maior = obj.ehMaior;
    this.formModal.nome = obj.nome;
    this.formModal.cpf = obj.cpf;
    this.formModal.email = obj.email;
    this.formModal.telefone = obj.telefone;
    this.formModal.cep = obj.endereco.cep;
    this.formModal.logradouro = obj.endereco.logradouro;
    this.formModal.bairro = obj.endereco.bairro;
    this.formModal.numero = obj.endereco.numero;
    this.formModal.complemento = obj.endereco.complemento;
    this.formModal.cidade = obj.endereco.cidade;
    this.formModal.estado = obj.endereco.estado;
    if (obj.responsavel != null) {
      this.formModal.nome_responsavel = obj.responsavel.nome;
      this.formModal.cpf_responsavel = obj.responsavel.cpf;
      this.formModal.telefone_responsavel = obj.responsavel.telefone;
    }
    document.getElementById(this.targetModal).classList.add("show");
  }

  /**
   * Bloquear o objeto
   * @param obj any
   */
  public block(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja bloquear o aluno?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ token: obj.token }, this.urlSearch + "/block", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Bloquear o objeto
   * @param obj any
   */
  public active(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja ativar o aluno?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ token: obj.token }, this.urlSearch + "/active", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  public checkCep() {
    if (this.formModal.cep == "" || this.formModal.cep == null) {
      return false;
    }

    this.msgHelper.createLoading("crescent", "Buscando Cep...");
    this.msgHelper.showLoading();

    this.service.postData({ cep: this.formModal.cep }, "/config/search-cep", false).then(result => {
      this.msgHelper.closeLoading();
      let resultData: any = result;
      if (resultData.result == 0) {
        this.formModal.cep = "";
        this.msgHelper.showToast(resultData.message, "bottom", 1500);
      }
      this.formModal.logradouro = resultData.data.logradouro;
      this.formModal.bairro = resultData.data.bairro;
      this.formModal.cidade = resultData.data.localidade;
      this.formModal.estado = resultData.data.uf;

    }, error => {
      this.msgHelper.closeLoading();
      console.log(error);
    });

  }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backPage() {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage() {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll() {
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  public backAll()
  {
    this.search();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      console.log(this.resultData);
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/alunos/alunos.ts